export function computeWarrantyExpiresAt(warranty: {
  expires_at?: string | null;
  active_from?: string | null;
  duration_in_months?: number | null;
}): string | null {
  if (warranty.expires_at) return warranty.expires_at;
  if (warranty.active_from && warranty.duration_in_months) {
    const start = new Date(warranty.active_from);
    if (!isNaN(start.getTime())) {
      start.setMonth(start.getMonth() + warranty.duration_in_months);
      return start.toISOString();
    }
  }
  return null;
}
